// Estilos con alcance (.est-*) de la pagina Estacionamiento (CA1). Una sola fuente para la
// vista, el plano y los puestos. Sin dependencias: se inyecta con <style>{ESTILOS}</style>.
export const ESTILOS = `
.est-root{
  --navy:#132752; --azul:#003366; --suave:#5A6784; --texto:#26334F; --borde:#DCE3EF;
  --azul-claro:#BFD1EA; --lila:#E4DDF1; --lila-borde:#5B4F8E;
  font-family:Inter,Montserrat,system-ui,-apple-system,'Segoe UI',sans-serif;
  color:var(--texto); max-width:1320px; margin:0 auto; padding:4px 0 28px;
}
.est-root *{box-sizing:border-box}
.est-root button{font-family:inherit}

/* ---------- Cabecera ---------- */
.est-cab{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:16px;margin-bottom:22px}
.est-cab-izq{display:flex;align-items:center;gap:16px;min-width:0}
.est-h1{margin:0;font-size:28px;line-height:1.12;font-weight:800;letter-spacing:-.015em;color:var(--navy)}
.est-sub{margin:4px 0 0;font-size:14.5px;color:var(--suave)}
.est-cab-der{display:flex;flex-wrap:wrap;align-items:center;gap:10px}
.est-stat{display:inline-flex;align-items:center;gap:9px;padding:9px 15px;border-radius:12px;background:#fff;
  border:1px solid var(--borde);font-size:14px;font-weight:600;color:#33405E;box-shadow:0 1px 2px rgba(19,39,82,.05)}
.est-stat b{color:var(--navy);font-weight:800}
.est-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:42px;padding:0 18px;border-radius:12px;
  border:1.5px solid var(--azul);background:linear-gradient(180deg,#0A4380,#003366);color:#fff;font-size:14px;font-weight:700;
  cursor:pointer;box-shadow:0 8px 18px -8px rgba(0,51,102,.6);transition:transform .15s,box-shadow .15s,background .15s}
.est-btn:hover{transform:translateY(-1px);box-shadow:0 12px 22px -8px rgba(0,51,102,.65)}
.est-btn.est-btn-claro{background:#fff;color:var(--navy);box-shadow:0 1px 2px rgba(19,39,82,.08)}
.est-btn.est-btn-claro:hover{background:#F2F6FC}
.est-btn:focus-visible,.est-chip:focus-visible,.est-sel-op:focus-visible,.est-x:focus-visible{outline:3px solid #003366;outline-offset:3px}

/* ---------- Leyenda (filtros) ---------- */
.est-leyenda{display:flex;flex-wrap:wrap;align-items:center;gap:10px;margin-bottom:16px}
.est-chip{display:inline-flex;flex:1 1 210px;min-width:0;align-items:center;gap:11px;padding:8px 14px 8px 9px;border-radius:14px;background:#fff;
  border:1.5px solid var(--borde);color:var(--navy);font-size:14px;font-weight:600;cursor:pointer;text-align:left;
  box-shadow:0 1px 2px rgba(19,39,82,.06);transition:transform .15s,border-color .15s,box-shadow .15s,background .15s}
.est-chip:hover{border-color:#8DA6CE;transform:translateY(-1px);box-shadow:0 6px 14px -8px rgba(19,39,82,.3)}
.est-chip[aria-pressed="true"]{background:#EAF1FB;border-color:var(--azul);box-shadow:0 0 0 3px rgba(0,51,102,.14)}
.est-chip-txt{display:flex;flex:1;min-width:0;flex-direction:column;line-height:1.2}
.est-chip-sub{font-size:11.5px;font-weight:600;color:var(--suave)}
.est-chip-n{flex:none;min-width:26px;height:24px;padding:0 8px;border-radius:999px;display:grid;place-items:center;background:#EEF2F9;
  color:var(--navy);font-size:12.5px;font-weight:800}
.est-chip[aria-pressed="true"] .est-chip-n{background:var(--azul);color:#fff}
.est-mini{width:30px;height:40px;flex:none;border-radius:8px;border:1.3px solid var(--navy);display:grid;place-items:center}
.est-limpiar{border:0;background:none;color:var(--azul);font-size:13.5px;font-weight:700;cursor:pointer;padding:8px 6px;text-decoration:underline;text-underline-offset:3px}
.est-limpiar:focus-visible{outline:3px solid #003366;outline-offset:2px;border-radius:6px}

/* Relleno por tipo (puestos, leyenda, ficha, selector) */
.est-tipo-libre{background:linear-gradient(180deg,#EEE9F8 0%,#E0D7F0 100%);border-color:var(--lila-borde)!important}
.est-tipo-privado_sura,.est-tipo-gerencia{background:linear-gradient(180deg,#CBDAF0 0%,#B5C9E6 100%)}
.est-tipo-privado{background:repeating-linear-gradient(135deg,rgba(19,39,82,.07) 0 5px,transparent 5px 11px),linear-gradient(180deg,#CBDAF0 0%,#B5C9E6 100%)}
.est-glifo-doble{display:inline-flex;flex-direction:column;align-items:center;gap:1px}

/* ---------- Tarjetas ---------- */
.est-card{background:#fff;border:1px solid var(--borde);border-radius:22px;
  }
.est-plano-card{padding:20px 20px 22px}
.est-card-cab{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:10px 16px;margin-bottom:14px}
.est-card-tit{margin:0;font-size:16px;font-weight:800;color:var(--navy);display:flex;align-items:center;gap:10px}
.est-card-tit span{font-weight:600;color:var(--suave);font-size:14px}
.est-aviso{display:inline-flex;align-items:center;gap:8px;padding:7px 12px;border-radius:10px;background:#EAF1FB;color:var(--navy);
  font-size:13.5px;font-weight:600;border:1px dashed #7F9ACB}

/* ---------- Plano ---------- */
.est-piso{position:relative;border-radius:18px;border:1px solid #DFE7F3;padding:4px 6px;
  background:radial-gradient(circle at 1px 1px,rgba(19,39,82,.075) 1px,transparent 1.5px) 0 0/18px 18px,linear-gradient(180deg,#F9FBFE 0%,#EEF2F9 100%)}
.est-piso.est-edicion{border-color:#7F9ACB;box-shadow:inset 0 0 0 2px rgba(0,51,102,.18)}
.est-scroll{overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scrollbar-width:thin}
.est-escala{position:relative;margin:0 auto}
.est-lienzo{position:absolute;left:0;top:0;transform-origin:0 0}
.est-carril{position:absolute;left:14px;right:14px;height:0;border-top:2px dashed rgba(19,39,82,.15)}
.est-celda{position:absolute}
.est-celda.est-celda-viva{z-index:6}
.est-puesto{position:relative;width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:space-between;
  padding:9px 0 8px;border-radius:10px;border:1.5px solid var(--navy);cursor:pointer;color:var(--navy);
  box-shadow:inset 0 1px 0 rgba(255,255,255,.8),0 1px 2px rgba(19,39,82,.16),0 6px 12px -8px rgba(19,39,82,.4);
  transition:transform .18s ease,box-shadow .18s ease,opacity .22s ease,filter .22s ease,border-color .18s ease;
  -webkit-tap-highlight-color:transparent}
.est-fila-inferior.est-puesto{padding:8px 0 9px}
.est-num{font-size:16px;line-height:1;font-weight:800;letter-spacing:.01em;font-variant-numeric:tabular-nums;color:var(--navy)}
.est-cuerpo{flex:1;width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px}
.est-tag{display:inline-block;padding:3px 5px;border-radius:999px;background:#fff;color:var(--navy);font-size:11px;font-weight:700;
  line-height:1.2;border:1px solid #93A9CC;box-shadow:0 1px 2px rgba(19,39,82,.14)}
.est-puesto:hover,.est-puesto.est-activo{transform:translateY(-4px);border-color:var(--azul);
  box-shadow:inset 0 1px 0 rgba(255,255,255,.85),0 0 0 2px rgba(0,51,102,.22),0 12px 18px -8px rgba(19,39,82,.5)}
.est-puesto[aria-pressed="true"]{transform:translateY(-4px);border-color:var(--azul);
  box-shadow:inset 0 1px 0 rgba(255,255,255,.85),0 0 0 3px var(--azul),0 12px 18px -8px rgba(19,39,82,.5)}
.est-puesto:focus-visible{outline:3px solid #003366;outline-offset:3px;z-index:7}
.est-puesto.est-atenuado{opacity:.34;filter:saturate(.5)}
.est-puesto.est-atenuado:hover{opacity:.75}
.est-puesto.est-resaltado{transform:translateY(-2px);box-shadow:inset 0 1px 0 rgba(255,255,255,.85),0 0 0 2.5px var(--azul),0 10px 16px -8px rgba(19,39,82,.5)}
.est-puesto.est-bloqueado{opacity:.5;filter:saturate(.4)}
.est-puesto.est-bloqueado::after{content:"";position:absolute;inset:0;border-radius:inherit;pointer-events:none;
  background:repeating-linear-gradient(135deg,rgba(19,39,82,.12) 0 2px,transparent 2px 9px)}
.est-puesto.est-bloqueado.est-resaltado,.est-puesto.est-bloqueado:hover{opacity:.78}
.est-edicion .est-puesto{outline:2px dashed rgba(0,51,102,.5);outline-offset:2px}
.est-edicion .est-puesto:focus-visible{outline:3px solid #003366;outline-offset:3px}

.est-rampa{position:absolute;pointer-events:none}
.est-rampa svg{display:block}
.est-auto-sube{animation:est-auto-sube 2.8s ease-in-out infinite}
.est-auto-baja{animation:est-auto-baja 2.8s ease-in-out infinite}
.est-rampa-b .est-auto-sube,.est-rampa-b .est-auto-baja{animation-delay:-1.4s}
@keyframes est-auto-sube{0%,100%{transform:translateY(8px)}50%{transform:translateY(-8px)}}
@keyframes est-auto-baja{0%,100%{transform:translateY(-8px)}50%{transform:translateY(8px)}}
.est-escalera{position:absolute;pointer-events:none;filter:drop-shadow(0 4px 5px rgba(19,39,82,.2))}
.est-escalera svg{display:block}
.est-nota{position:absolute;display:flex;align-items:center;justify-content:center;text-align:center;padding:6px 10px;border-radius:10px;
  background:linear-gradient(180deg,#F0ECF9,#E2DAF1);border:1.4px solid var(--lila-borde);color:var(--navy);
  font-size:14px;font-weight:600;line-height:1.28;box-shadow:0 6px 12px -8px rgba(19,39,82,.4)}

/* Selector de tipo (modo edicion) */
.est-selector{position:absolute;z-index:30;width:264px;padding:8px;background:#fff;border:1px solid var(--borde);border-radius:14px;
  box-shadow:0 22px 44px -14px rgba(19,39,82,.45),0 2px 8px rgba(19,39,82,.14)}
.est-sel-cab{display:flex;align-items:center;justify-content:space-between;padding:0 4px 4px 8px;font-size:12px;font-weight:800;
  letter-spacing:.05em;text-transform:uppercase;color:var(--suave)}
.est-x{display:grid;place-items:center;width:26px;height:26px;border:0;border-radius:8px;background:transparent;color:var(--suave);cursor:pointer}
.est-x:hover{background:#EEF2F9;color:var(--navy)}
.est-sel-op{display:flex;align-items:center;gap:10px;width:100%;min-height:38px;margin-top:2px;padding:4px 8px;border:0;border-radius:10px;
  background:transparent;color:var(--navy);font-size:14px;font-weight:600;text-align:left;cursor:pointer;white-space:nowrap}
.est-sel-op:hover:not(:disabled){background:#EEF3FB}
.est-sel-op[aria-pressed="true"]{background:#E1EBF9}
.est-sel-op:disabled{cursor:wait;opacity:.7}
.est-sel-op .est-mini{width:24px;height:32px;border-radius:7px}
.est-sel-txt{flex:1;line-height:1.2}

/* ---------- Detalle + terraza ---------- */
.est-inferior{display:grid;grid-template-columns:minmax(0,1.55fr) minmax(0,1fr);gap:16px;margin-top:16px}
.est-detalle{display:flex;align-items:center;gap:22px;padding:20px 24px;min-height:156px}
.est-ficha{width:84px;height:116px;flex:none;border-radius:12px;border:1.5px solid var(--navy);display:flex;flex-direction:column;
  align-items:center;justify-content:center;gap:6px;box-shadow:inset 0 1px 0 rgba(255,255,255,.8),0 10px 18px -10px rgba(19,39,82,.45)}
.est-ficha.est-vacia{border-style:dashed;border-color:#A9B8D3;background:#F6F8FC;color:#7C8AA5;box-shadow:none}
.est-eyebrow{font-size:12px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:var(--suave)}
.est-det-num{font-size:46px;line-height:1;font-weight:800;color:var(--navy);letter-spacing:-.02em;margin:2px 0 8px;font-variant-numeric:tabular-nums}
.est-det-fila{display:flex;flex-wrap:wrap;gap:8px;align-items:center}
.est-insig{display:inline-flex;align-items:center;gap:7px;padding:5px 11px;border-radius:999px;font-size:13px;font-weight:700;color:var(--navy);
  background:#E6EDF8;border:1px solid #B9C9E3}
.est-insig.est-ins-lila{background:#EAE5F5;border-color:#C5BAE0}
.est-ok{background:#E4F4EA;border-color:#A9D8B9;color:#14532D}
.est-no{background:#F0F2F7;border-color:#CBD3E2;color:#38445F}
.est-det-desc{margin:10px 0 0;font-size:15px;line-height:1.45;color:var(--texto)}
.est-vacio-t{margin:0;font-size:15px;line-height:1.5;color:var(--suave)}
.est-terraza{display:flex;align-items:center;gap:18px;padding:22px 26px;
  background:linear-gradient(135deg,#F3EFFA 0%,#E6DEF3 100%);border-color:#CFC4E6}
.est-terraza p{margin:0;font-size:18px;line-height:1.4;color:var(--navy)}
.est-terraza strong{font-weight:800}
.est-terraza-ico{width:56px;height:56px;border-radius:16px;flex:none;display:grid;place-items:center;background:#fff;
  box-shadow:0 8px 16px -10px rgba(91,79,142,.7)}

/* ---------- Carga / error ---------- */
.est-sk{border-radius:10px;background:linear-gradient(90deg,#E9EEF7 0%,#F6F8FC 50%,#E9EEF7 100%);background-size:220% 100%;animation:est-brillo 1.5s ease-in-out infinite}
@keyframes est-brillo{0%{background-position:120% 0}100%{background-position:-120% 0}}
.est-sk-fila{display:flex;gap:8px;padding:16px 14px}
.est-error{display:flex;flex-direction:column;align-items:center;gap:12px;text-align:center;padding:56px 20px}
.est-error p{margin:0;color:var(--texto);font-size:15px}
.est-error h2{margin:0;color:var(--navy);font-size:18px;font-weight:800}
.est-hint{display:none;margin:8px 4px 2px;font-size:12.5px;color:var(--suave);text-align:center}
.est-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}

@media (max-width:860px){
  .est-inferior{grid-template-columns:1fr}
}
@media (max-width:640px){
  .est-hint{display:block}
  .est-h1{font-size:23px}
  .est-plano-card{padding:14px 12px 16px}
  .est-detalle{padding:16px;gap:16px}
  .est-ficha{width:70px;height:98px}
  .est-det-num{font-size:38px}
  .est-terraza{padding:18px 20px}
  .est-terraza p{font-size:16px}
  .est-terraza-ico{width:48px;height:48px}
}
@media (prefers-reduced-motion:reduce){
  .est-root *,.est-root *::before,.est-root *::after{animation:none!important;transition:none!important}
}
`;
